import { h } from 'preact';

export default function CheckCircleSolid(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="M16 2a14 14 0 100 28 14 14 0 000-28zm6.2 11.28l-5.77 7.63a1.49 1.49 0 01-2.14.25l-4.61-3.75a1.5 1.5 0 111.89-2.32l3.4 2.77 4.83-6.39c.5-.66 1.44-.79 2.11-.29.66.5.79 1.44.29 2.1z"
      />
    </svg>
  );
}

